export default [
  {
    route: 'parley-setup',
  },
  {
    route: 'parley-data-form',
  }
];